module.exports = "<div class=\"state-container\">\n  <i class=\"icon\" [ngClass]=\"state.icon\"></i>\n  <div class=\"text\"> {{ state.text }} </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/states/states.component.html
// module id = ./src/app/components/states/states.component.html
// module chunks = main